// extracted by mini-css-extract-plugin
export default {"editButton":"fixedAllowance_editButton__4Pj8p","TableBody":"fixedAllowance_TableBody__TRpPx"};